import React, { ReactElement } from 'react';
import Logo from './RaptorLogoWithText.png';

interface Props {
  width?: number;
  opacity?: number;
}

// The logo must render at a fixed, predictable width in flex layouts.
// Many CSS baselines apply `img { max-width: 100% }`, which causes images to shrink to fit the parent.
// We override that with `maxWidth: 'none'` and set `flexShrink: 0` so the logo does not compress.
// `height: 'auto'` preserves aspect ratio while using the provided width.
function RaptorLogo(props: Props): ReactElement {
  return (
    <img
      src={Logo}
      alt="Raptor logo"
      style={{
        width: props.width || 160,
        opacity: props.opacity || 1,
        maxWidth: 'none',
        height: 'auto',
        flexShrink: 0,
      }}
    />
  );
}

export default RaptorLogo;
